import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref) {
  var fluid = _ref.fluid,
    size = _ref.size,
    sizes = _ref.sizes;
  return {
    root: {
      paddingLeft: theme.spacing.md,
      paddingRight: theme.spacing.md,
      maxWidth: fluid ? "100%" : theme.fn.size({
        size: size,
        sizes: sizes
      }),
      marginLeft: "auto",
      marginRight: "auto"
    }
  };
});
export default useStyles;